import { VDateTime, VTimeSpan } from '@datarock/protobuffers';
import moment from 'moment';
export function dateToVDateTime(date) {
    if (!date) {
        return undefined;
    }
    return VDateTime.fromJSON({
        epochUTC: moment.utc(date).unix(),
        offset: VTimeSpan.fromJSON({
            hours: -(date.getTimezoneOffset() / 60),
            minutes: 0,
            seconds: 0
        })
    });
}
export function ISODate(isoString) {
    if (!isoString)
        return null;
    return new Date(isoString);
}
